import { create } from 'zustand';

import { IHttpError } from 'models/interface';
import { RankingProjectService } from '../services/rankingProject.service';
import { IRankingProjectCard } from '../models/interface';

interface RankingProjectListState {
    rankingProjectsLoader: boolean;
    dataFetchError: IHttpError | null;
    rankingProjects: IRankingProjectCard[] | null;
    refreshRankingProjectList: (project_slug: string) => Promise<void>;
}

const useStore = create<RankingProjectListState>((set) => ({
    rankingProjectsLoader: true,
    dataFetchError: null,
    rankingProjects: null,

    refreshRankingProjectList: async (project_slug: string) => {
        set(() => ({ rankingProjectsLoader: true }));
        try {
            const { data } = await new RankingProjectService().getRankingProjects(project_slug);
            set(() => ({
                rankingProjects: data.data.ranking_projects ? [...data.data.ranking_projects] : [],
                rankingProjectsLoader: false,
                dataFetchError: null
            }));
        } catch (error: any) {
            set(() => ({ dataFetchError: error, rankingProjectsLoader: false }));
        }
    }
}));

export const useRankingProjectListStore = useStore;
